<template>
  <div>
    <!-- 附加服务费 -->
    <el-dialog :title="$t('message.additionalServiceCharge')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">
        <div class="table">
          <ol>
            <!-- 附加服务 -->
            <li class="flex15">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 数量 -->
            <li>
              {{ $t("message.quantity") }}
            </li>
            <!-- 小计 -->
            <li>
              {{ $t("message.SubtotalYuan") }}
            </li>
          </ol>
          <ul v-for="(item, index) in option" :key="index">
            <!-- 附加服务 -->
            <li class="flex15">
              {{ item.name }}
            </li>
            <!-- 数量 -->
            <li>
              {{ item.num }}
            </li>
            <!-- 小计 -->
            <li>
              {{ item.total }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NP from 'number-precision' //NP.strip 处理浮点数
export default {
  props: {
    detail: { type: Object }
  },
  computed: {
    // ...mapState({
    //   detail: (state) => state.orderDetail.detail,
    // }),
    option() {
      let status = this.detail.status
      let list = []
      this.detail.order_detail.forEach(item => {
        if (item.option) {
          item.option.forEach(option => {
            let index = list.findIndex(items => option.name == items.name)
            if (index != -1) {
              list[index].num = list[index].num - 0 + (option.num - 0)
              if (option.price_type != 1) {
                list[index].total += option.num * option.price
              } else {
                if (status == 20) {
                  list[index].total += this.ceil((NP.strip(item.price * option.num) * (option.price / 100)))
                } else {
                  list[index].total += this.ceil((NP.strip(item.offer_price * option.num) * (option.price / 100)))
                }
              }
            } else {
              let optionItem = JSON.parse(JSON.stringify(option))
              optionItem.total = 0
              if (optionItem.price_type != 1) {
                optionItem.total += optionItem.num * optionItem.price
              } else {
                if (status == 20) {
                  optionItem.total += this.ceil((NP.strip(item.price * optionItem.num) * (optionItem.price / 100)))
                } else {
                  optionItem.total += this.ceil((NP.strip(item.offer_price * optionItem.num) * (optionItem.price / 100)))
                }
              }
              list.push(optionItem)
            }
          })
        }
      })
      return list
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  max-height: 600px;
  overflow-y: auto;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 40px;
    }

    .val {
      flex: 3;
    }
  }

  .table {

    ol {
      display: flex;
      position: sticky;
      left: 0;
      top: 0
    }

    ul {
      display: flex;
      padding: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  /deep/.el-input {
    width: 60%;
  }

  /deep/.el-select {
    .el-input {
      width: 100%;
    }

    width: 80%;
  }
}
</style>